module.exports = __webpack_public_path__ + "static/media/od_1.399f202e.png";